var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "All-Resources"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.91988 15.0209H13.7865V20.8876H7.91988V15.0209ZM1.07544 7.1987H6.94211V1.33203H1.89433C1.67715 1.33203 1.46886 1.41831 1.31529 1.57188C1.16172 1.72545 1.07544 1.93374 1.07544 2.15092V7.1987ZM1.89433 20.8876H6.94211V15.0209H1.07544V20.0687C1.07544 20.2859 1.16172 20.4942 1.31529 20.6477C1.46886 20.8013 1.67715 20.8876 1.89433 20.8876ZM1.07544 14.0431H6.94211V8.17648H1.07544V14.0431ZM14.7643 20.8876H19.8243C20.0394 20.8844 20.2445 20.7967 20.3955 20.6435C20.5464 20.4902 20.631 20.2838 20.631 20.0687V15.0209H14.7643V20.8876ZM7.91988 14.0431H13.7865V8.17648H7.91988V14.0431ZM14.7643 14.0431H20.631V8.17648H14.7643V14.0431ZM14.7643 1.33203V7.1987H20.631V2.15092C20.631 1.93584 20.5464 1.72938 20.3955 1.57616C20.2445 1.42293 20.0394 1.33524 19.8243 1.33203H14.7643ZM7.91988 7.1987H13.7865V1.33203H7.91988V7.1987Z",
    fill: "url(#paint0_linear_1203_21355)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1203_21355",
    x1: 10.8532,
    y1: 20.8876,
    x2: 10.8532,
    y2: 1.33203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E9624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#5E9724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#6CAB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#73B82C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76BC2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllResources);
export default __webpack_public_path__ + "static/media/All-Resources.0db704948e5c1708b06d84e7c9d5b479.svg";
export { ForwardRef as ReactComponent };